import {createSlice} from '@reduxjs/toolkit'

const chatSlice = createSlice({
    name: 'chat',
    initialState: {
        room: null,
        friendsList: null,
        newUserInChat: null,
        inChatWith: null,
        currChat: null,
        socket: null,
        messageData: null,
        globalErr: null
    },
    reducers: {
        setSocket(state, action) {
            state.socket = action.payload.socket;
        },
        setRoom(state, action) {
            state.room = action.payload.roomId;
            if(!action.payload.userId || !action.payload.name) return
            state.inChatWith = {
                _id: action.payload.userId ,
                name: action.payload.name
            }



        },
        addNewUser(state, action) {
            if(action.payload.reset) {
                state.newUserInChat = null
                return
            };
            state.newUserInChat = {
                name: action.payload.name || null,
                _id: action.payload._id || null,
                roomId: action.payload.roomId || null
            }
            state.room = action.payload.roomId || null
            state.inChatWith = {
                name: action.payload.name,
                _id: action.payload._id
            }
        },
        setFriendsList(state, action) {
            state.friendsList = action.payload.friends
        },
        getMessages(state, action) {
            state.currChat = action.payload.messages;
        },
        reset(state, action) {
            state.room = null;
            state.friendsList = null;
            state.newUserInChat = null;
            state.inChatWith = null;
            state.currChat = null;
            state.socket = null
        },
        setMessageData(state, action) {
            state.messageData = action.payload.data
        },
        setGlobalError(state, action){
            state.globalErr = action.payload
        }
    
    }
})



export const chatActions = chatSlice.actions;
export default chatSlice;